module.exports = __webpack_public_path__ + "img/Chris_round.539574d0.png";